import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { renderHTMLString } from '../../../../../../../helpers';
import { renderStyledElementStyles } from '../../../../../helpers';
import { getVenueData } from '../../../../../../../store/siteDucks/siteHeader';
import { selectPageConfig } from '../../../../../../../store/features/pageConfig';

const Wrapper = styled.div`
  ${({ theme }) => {
    return renderStyledElementStyles(
      theme,
      theme.siteLayout.siteHeader.builder?.elements?.venue?.event,
    );
  }}
  text-align: ${({ theme }) => (theme.globalVariables.isRTL ? 'left' : 'right')}
`;

const Date = styled.div`
  ${({ theme }) => {
    return renderStyledElementStyles(
      theme,
      theme.siteLayout.siteHeader.builder?.elements?.venue?.event?.elements
        ?.date,
    );
  }}
`;

const Address = styled.span`
  ${({ theme }) => {
    return renderStyledElementStyles(
      theme,
      theme.siteLayout.siteHeader.builder?.elements?.venue?.event?.elements
        ?.address,
    );
  }}
`;

export default function EventVenue() {
  const { formattedDate, venueName, venueCity, shortInfo } =
    useSelector(getVenueData);
  const { location } = useSelector(selectPageConfig);

  return (
    <Wrapper data-testid="header-event-venue">
      {formattedDate && (
        <Date dir="ltr">{renderHTMLString(formattedDate, location)}</Date>
      )}
      {venueName && <Address>{venueName}</Address>}
      {venueCity && <span>{venueCity}</span>}
      {shortInfo && <div>{renderHTMLString(shortInfo, location)}</div>}
    </Wrapper>
  );
}
